import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledSubcategory = styled.div`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[300])};
`;

export const StyledImageWrapper = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 6px;
  border-radius: 6px;
  border: 1px solid rgba(214, 219, 225);

  img {
    max-width: 100%;
  }
`;

export const StyledDate = styled.div`
  flex: 1 0 auto;
  ${setFontVariant('report', colorsPalettes.carbon[400])};
  text-align: right;
`;
